import delve from 'dlv';

import LocalStorage, { StorageKeys } from 'utils/local-storage';

import { IStorePrepaidCard } from './types';

export const storePrepaidCard = ({ accounts }: IStorePrepaidCard) => {
  const prepaidCard = accounts.find(method => Boolean(method.prepaid)) || {};
  const { shuffledCardNumber } = delve(prepaidCard, 'prepaid', {});
  if (!shuffledCardNumber) {
    LocalStorage.removeItem(StorageKeys.TIMCARD);
    return;
  }
  LocalStorage.setItem(StorageKeys.TIMCARD, shuffledCardNumber);
};

export const getStoredPrepaidCard = () => {
  const accountNumber = LocalStorage.getItem(StorageKeys.TIMCARD);
  if (!accountNumber) {
    return null;
  }

  return accountNumber;
};
